import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const trimTrailingSlash = (path) => path.replace(/\/$/, '');

export const isMenuItemActive = (pathname, item) => {
  const url = item?.url?.trim();
  if (!url) return false;

  const normalizedUrl = trimTrailingSlash(url);
  const normalizedPath = trimTrailingSlash(pathname);

  if (normalizedPath === normalizedUrl || normalizedPath.startsWith(`${normalizedUrl}/`)) {
    return true;
  }

  if (item.alias_name) {
    const [pathHead] = normalizedPath.split('/').filter(Boolean);
    const [urlHead] = normalizedUrl.split('/').filter(Boolean);
    return pathHead === item.alias_name && urlHead === item.alias_name;
  }

  return false;
};

export default function useRouteMatch() {
  const { pathname } = useLocation();
  return useMemo(() => ({ isActive: (item) => isMenuItemActive(pathname, item) }), [pathname]);
}
